import Vue from 'vue'

const Coupon = class {
  constructor({
    id,
    type,
    name,
    description,
    minimumPurchaseAmount,
    discountRate,
    overlapUsage,
    maximumDiscountAmount,
    maximumDiscountAmountText,
    registrationDate,
    expirationDate,
    displayProductIds,
    displayCatalogIds,
    unavailableMessage,
    available = false,
    firstPurchaseCoupon
  }) {
    this.id = id
    this.type = type
    this.name = name
    this.description = description
    this.minimumPurchaseAmount = minimumPurchaseAmount
    this.discountRate = discountRate
    this.overlapUsage = overlapUsage
    this.maximumDiscountAmount = maximumDiscountAmount
    this.maximumDiscountAmountText = maximumDiscountAmountText
    this.registrationDate = registrationDate
    this.displayCatalogIds = displayCatalogIds
    this.expirationDate = {
      startDate: expirationDate ? expirationDate.startDate : null,
      endDate: expirationDate ? expirationDate.endDate : null
    }
    this.displayProductIds = displayProductIds
    this.unavailableMessages = !!unavailableMessage ? unavailableMessage.split('\n') : ''

    this.available = available
    this.firstPurchaseCoupon = firstPurchaseCoupon === 'Y'
  }

  // FIXME maximumDiscountAmount 로 변경?
  get amount() {
    return this.maximumDiscountAmount
  }

  get amountText() {
    return this.maximumDiscountAmountText
  }

  get expirationText() {
    const {
      endDate
    } = this.expirationDate

    const endDateTime = Vue.time(endDate)
    const todayDateTime = Vue.time(Date.now())
    const remainingDays = endDateTime.diff(todayDateTime, 'days')

    const endDays = endDateTime.format('YYYY/MM/DD')

    if (remainingDays === 0) return `오늘까지 (${endDays})`

    return `${remainingDays}일 후 만료 (${endDays})`
  }

  toRequest() {
    return {
      id: this.id,
      name: this.name,
      amount: this.maximumDiscountAmount
    }
  }
}

export default null

export const ofCoupon = (params = {}) => new Coupon(params)
